import { useStations } from '../hooks/useStations';
import type { Station } from '@shared/types';

export default function StationSelect({ onSelect }: { onSelect: (s: Station) => void }) {
  const { stations } = useStations();
  return (
    <div className="mx-auto max-w-2xl px-4 py-8">
      <h1 className="text-xl font-bold text-white mb-1">Choose a station</h1>
      <p className="text-sm text-zinc-400 mb-6">Pick the location you're building a request for.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {stations.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onSelect(s)}
            className="glass rounded-xl p-4 text-left text-white hover:border-dcvfd-accent transition-colors"
          >
            <div className="font-semibold">{s.name}</div>
            {s.code && <div className="text-xs text-zinc-400">{s.code}</div>}
          </button>
        ))}
      </div>
    </div>
  );
}
